import { NewsItem_NewsItemEdgeFragment } from 'generated/graphql'
import { CHANNEL_META } from 'constants/metaData'

export type TChannelOgData = {
  title: string
  image: string
}

interface IFProps {
  data: Omit<NewsItem_NewsItemEdgeFragment, 'cursor' | '__typename'>
}

const getChannelOgData = ({ data }: IFProps) => {
  const ogData: TChannelOgData = {
    title:
      `${data.header?.channel?.name} - 기업채널 | 링커리어` ||
      CHANNEL_META.title,
    image:
      data.content?.images.nodes[0]?.url ||
      'https://linkareer.com/static/images/channel/channel-seo.png',
  }

  return ogData
}
export default getChannelOgData
